import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <CommentsSection />
        <ContactSection />
        <MediaSection />
        <AppSection />
        <IndexSection />
        <CarouselSection />
        <FeaturesSection />
        <RankingSection />
        <AboutSection />
        <FaqSection />
        <UpdatesSection />
        <CardsSection />
      </main>
      <Footer />
    </>
  );
}